module.exports = __webpack_public_path__ + "img/Font 19.d08bf969.jpg";